module.exports = __webpack_public_path__ + "static/img/curso_garantias.de919a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/curso_garantias.png
// module id = P1LG
// module chunks = 9